import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

export default function Categories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/categories").then((r) => setCategories(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="shell py-5 sm:py-7 animate-fade-up">
      <div className="surface px-5 sm:px-8 py-6 mb-5">
        <h1 className="font-display text-3xl font-bold text-deep">All Categories</h1>
        <p className="text-sm text-muted-foreground">Browse products across all categories.</p>
      </div>
      {loading ? (
        <div className="text-center py-16 text-muted-foreground">Loading…</div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-5">
          {categories.map((c) => (
            <Link
              key={c.slug}
              to={`/products?category=${c.slug}`}
              className="group surface overflow-hidden hover:-translate-y-1 hover:shadow-[0_18px_40px_-20px_rgba(6,48,28,0.35)] transition-all duration-300"
              data-testid={`category-card-${c.slug}`}
            >
              <div className="aspect-[4/3] overflow-hidden bg-muted">
                <img src={c.image} alt={c.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
              </div>
              <div className="p-4">
                <p className="font-bold text-deep group-hover:text-primary transition-colors">{c.name}</p>
                <p className="text-sm text-muted-foreground">{c.product_count} products</p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
